<template>
  <div class="meet-pub"></div>
</template>

<script>
import OT from "@opentok/client";

export default {
  name: "meet-publisher",

  props: ["session"],

  data() {
    return {
      publisher: null
    };
  },

  mounted() {
    const options = {
      insertMode: "append",
      width: "100%",
      height: "100%"
    };
    this.publisher = OT.initPublisher(this.$el, options, err => {
      if (err) {
        this.$emit("error", err);
      } else {
        this.$emit("publisherCompleted");
      }
    });
    this.$emit("publisherCreated", this.publisher);
    const publish = () => {
      this.session.publish(this.publisher, err => {
        if (err) {
          this.$emit("error", err);
        } else {
          this.$emit("publisherConnected", this.publisher);
        }
      });
    };
    if (this.session && this.session.isConnected()) {
      publish();
    }
    if (this.session) {
      this.session.on("sessionConnected", publish);
    }
  },

  destroyed() {
    this.session.unpublish(this.publisher);
  }
};
</script>

<style lang="scss" scoped>
.meet-pub {
  position: absolute;
  width: 100px;
  height: 75px;
  bottom: 10px;
  left: 10px;
  z-index: 100;
  border: 3px solid white;
  border-radius: 3px;
}
</style>
